import $ from 'jquery'
import DateFilter from '@/components/date-filter';
import store_examen from '@/store/mods/clinique/examens';
import store_caisse from '@/store/mods/caisse/operations';

export default {
    name: 'bon-examen',
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',
            is_month: false,

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'ref', label: 'Référence' }, 'patient', 'date',
                { key: 'action', label: 'Action.s' }
            ],

            filter: "",
            perPage: 15,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,

            filename: '',
            selected_bon: {
                date: "",
                reference: "",
                nom_patient: "",
                sexe: "",
                telephone: "",
                assurance: null,
                societe_souscripteur: null,
                prestations: [
                    {
                        libelle: "",
                        prix_clinique: "",
                        montant_du: "",
                        montant_restant: null,
                        remise: null,
                        etat_annulation: null,
                        etat_paiement: "",
                        qte: "",
                        montant_paye: "",
                        part_assureur: null,
                        base_assurance: null,
                        taux_couverture: null,
                    },
                ]
            },
            total_du: 0,
            total_a_payer: 0,
            info_prestation: {
                total_prix_assure: 0,
                total_base_assurance: 0,
                total_part_assureur: 0,
                total_remise: 0,
                taux_couverture: ''
            },
            
            prestation: '',
            total_taxe_specifique: 0,
            print_data: {},
            bons_examen_factures: []
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.is_month = true
            this.fetchBulletinExamen()
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        this.$store.commit("SET_BONS_EXAMEN_FACTURES", []);
        
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.fetchBulletinExamen()
    },

    methods: {
        fetchBulletinExamen() {
            this.is_load_error = false
            this.is_loading = true
            store_examen.getBulletinExamen(this.current_date_filter).then((response) => {
                this.bons_examen_factures = response.data
                this.total_pages = response.last_page
                if (this.bons_examen_factures.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.fetchBulletinExamen()
        },

        async viewInfoFacturation(info_bon) {
            this.selected_bon.date = info_bon.date
            this.selected_bon.reference = info_bon.reference
            this.selected_bon.nom_patient = info_bon.nom_patient
            this.selected_bon.sexe = info_bon.sexe
            this.selected_bon.age = info_bon.age
            this.selected_bon.telephone = info_bon.telephone
            this.selected_bon.assurance = info_bon.assurance
            this.selected_bon.societe_souscripteur = info_bon.societe_souscripteur

            this.info_prestation.total_remise  = 0
            this.info_prestation.total_base_assurance = 0
            this.info_prestation.total_prix_assure = 0
            this.info_prestation.total_part_assureur = 0
            this.total_a_payer = 0
            this.total_du  = 0

            const data = {
                uids: info_bon.uids
            }

            await store_caisse.getInfoFacturationBonMedical(data).then((response) => {
                this.prestation = 'Bon d\'examen'
                this.selected_bon.prestations = response

                response.forEach(prestation => {
                    this.total_du += prestation.montant_du
                    this.total_a_payer += (prestation.prix_clinique > prestation.base_assurance)?prestation.prix_clinique:prestation.base_assurance

                    this.info_prestation.taux_couverture = prestation.taux_couverture

                    if (prestation.remise > 0) {
                        this.info_prestation.total_remise += prestation.remise
                    }

                    if (prestation.base_assurance > 0) {
                        this.info_prestation.total_base_assurance += prestation.base_assurance
                    }

                    if (prestation.prix_assure_clinique > 0) {
                        this.info_prestation.total_prix_assure += prestation.prix_assure_clinique
                    }

                    if (prestation.part_assureur > 0) {
                        this.info_prestation.total_part_assureur += prestation.part_assureur
                    }

                    this.total_taxe_specifique += prestation.taxe_specifique
                })

                this.print_data = {
                    data_type: 'bon_analyse',   
                    prestation: this.prestation,
                    selected_bon: this.selected_bon,
                    info_prestation: this.info_prestation,
                    total_taxe_specifique: this.total_taxe_specifique,
                    total_a_payer: this.total_a_payer,
                    total_du: this.total_du
                }
            
                setTimeout(() => {
                    this.$emit('emitPrintBon', this.print_data)
                }, 200); 
            })
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.fetchBulletinExamen()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.fetchBulletinExamen()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.fetchBulletinExamen()
            }
        },
    }
}
